module.exports = __webpack_public_path__ + "img/Constrera.3f60b350.jpg";